export default "__VITE_ASSET__Cgk8Tiu2__"